import { ColumnType, GroupColumn } from "../useTable/types"

export type GroupColumnHelper<T> = (
  col: Omit<GroupColumn<T>, "type">
) => GroupColumn<T>

export function group<T>(col: Omit<GroupColumn<T>, "type">): GroupColumn<T> {
  return {
    type: ColumnType.Group,
    ...col,
  }
}
